import type { BRCYCodes } from "brandRegionConfig";
import { useBrand } from "core/hooks/useBrand";
import { useRegion } from "./useRegion";

export function useBrcyCode() {
  const countryIso2AlphaCode = useRegion();
  const { brandTwoLetterCode } = useBrand();
  return `${brandTwoLetterCode}${countryIso2AlphaCode}`.toUpperCase() as BRCYCodes;
}
